module.exports = __webpack_public_path__ + "img/ab-page4-bj.22aa6ab7.png";